import {ReactComponent as ArticlesIcon} from "@assets/icons/articles.svg";
import {ReactComponent as SpecialistsIcon} from "@assets/icons/specialists.svg";
import {ReactComponent as StatisticsIcon} from "@assets/icons/statistics.svg";
import {ReactComponent as SettingsIcon} from "@assets/icons/settings.svg";

export const navigation = [
    {name: 'Statystyki', href: '/app', Icon: StatisticsIcon},
    {name: 'Artykuły', href: '/app/articles', Icon: ArticlesIcon},
    {name: 'Specjaliści', href: '/app/specialists', Icon: SpecialistsIcon},
    {name: 'Ustawienia', href: '/app/settings', Icon: SettingsIcon},
];


